import { Button } from "@/components/ui/button";
import BlockbrainStore from "@/stores/BlockbrainStore";
import { useTranslation } from "react-i18next";
import { useBlockbrainCredentials } from "@/hooks/useBlockbrainCredentials";

export function SaveBlockbrainButton() {
  const { t } = useTranslation();
  const hasChanges = BlockbrainStore(state => state.hasChanges);
  const { isLoading, handleSaveCredentials } = useBlockbrainCredentials();

  return (
    <Button
      onClick={handleSaveCredentials}
      className="w-full p-0 h-9"
      disabled={isLoading || !hasChanges}
    >
      {t("common.save")}
    </Button>
  );
}
